import { Component, OnInit } from '@angular/core';
import { OnboardingStore } from '@boxx/onboarding-core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-image-title',
  templateUrl: './image-title.component.html',
  styleUrls: ['./image-title.component.scss'],
})
export class ImageTitleComponent implements OnInit {
  logoUrl = '';
  destroyed$ = new Subject<boolean>();

  constructor(private onboardingStore: OnboardingStore) {}

  ngOnInit() {
    this.onboardingStore.businessConfig.businessData$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(async (businessData) => {
        if (!businessData) {
          return;
        }
        this.logoUrl = businessData?.images.logo_image?.content;
      });

    this.onboardingStore.businessConfig.fetched$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((fetched) => {
        if (!fetched) {
          this.onboardingStore.businessConfig.getBusinesData();
        }
      });
  }
}
